import { useEffect, useState } from "react";
import { Services, ServicesContext } from "./app/services.ts";
import { Shell } from "./app/Shell.tsx";
import { SignIn } from "./auth/SignIn.tsx";
import { session, type SessionState } from "./auth/session.ts";
import { store } from "./data/store.ts";
import styles from "./App.module.css";

/** Signed out: the sign-in (docs/web-designs screen 1). Signed in: chats and the rest. */
export function App() {
  const [state, setState] = useState<SessionState | null | "loading">("loading");
  const [services, setServices] = useState<Services | null>(null);
  const userId = state && state !== "loading" ? state.user.id : null;

  useEffect(() => {
    const unsubscribe = session.subscribe(setState);
    session.resume().catch(() => setState(null));
    return unsubscribe;
  }, []);

  // One set of services per signed-in user; signing out tears it down and forgets everything.
  useEffect(() => {
    if (!userId) return;
    const s = new Services(session, store);
    s.start();
    setServices(s);
    return () => {
      s.stop();
      setServices(null);
    };
  }, [userId]);

  if (state === "loading" || (state && !services)) return <main className={styles.page} aria-busy />;
  if (!state) return <SignIn />;
  return (
    <ServicesContext.Provider value={services}>
      <Shell />
    </ServicesContext.Provider>
  );
}
